/**
 * jsPDF için Türkçe (DejaVu) font yükleyici.
 * Hem gün sonu PDF'i hem finans özeti aynı fontları kullanıyor; ortak modül
 * olmasının nedeni iki dosyanın birbirini import edip döngü oluşturmaması.
 * Fontlar bir kez indirilip önbelleğe alınır.
 */
const FONT_CACHE = { ready: false };

function arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunk));
  }
  return btoa(binary);
}

export async function ensureTurkishFonts(doc) {
  if (!FONT_CACHE.ready) {
    const controller = new AbortController();
    const t = setTimeout(() => controller.abort(), 15000);
    try {
      const [regularRes, boldRes] = await Promise.all([
        fetch(`${process.env.PUBLIC_URL || ''}/fonts/DejaVuSans.ttf`, {
          signal: controller.signal,
        }),
        fetch(`${process.env.PUBLIC_URL || ''}/fonts/DejaVuSans-Bold.ttf`, {
          signal: controller.signal,
        }),
      ]);
      if (!regularRes.ok || !boldRes.ok) {
        throw new Error('Türkçe PDF fontları yüklenemedi');
      }
      FONT_CACHE.regular = arrayBufferToBase64(await regularRes.arrayBuffer());
      FONT_CACHE.bold = arrayBufferToBase64(await boldRes.arrayBuffer());
      FONT_CACHE.ready = true;
    } finally {
      clearTimeout(t);
    }
  }
  doc.addFileToVFS('DejaVuSans.ttf', FONT_CACHE.regular);
  doc.addFont('DejaVuSans.ttf', 'DejaVuSans', 'normal');
  doc.addFileToVFS('DejaVuSans-Bold.ttf', FONT_CACHE.bold);
  doc.addFont('DejaVuSans-Bold.ttf', 'DejaVuSans', 'bold');
}

export default ensureTurkishFonts;
